<template>
    <div>
        <!-- <img class="logoImg" v-show="!$store.state.global.isTest" src="../assets/common/logo.png" alt=""> -->
        <!-- <img class="returnImg" @click=onReturn v-show="$store.state.global.isTest" src="../assets/common/return.png" alt=""> -->
        <img class="returnImg" v-show="!$store.state.global.isTrans" @click=onReturn src="../assets/common/home1.png" alt="">
        <img class="returnImg" v-show="$store.state.global.isTrans" @click=onReturn src="../assets/common/home2.png" alt="">
    </div>
</template>

<script>
    import wx from 'weixin-js-sdk'
    export default {
        name:'Logo',
        methods:{
            onReturn(){
                wx.miniProgram.navigateBack({delta: 1});
                // if(this.$store.state.global.itemNum===7){
                //     this.$router.push('/sejueDescription')
                // }
                // else{
                //     this.$router.push('/commonDescription')
                // }
            }
        }
    }
</script>

<style scoped>
    .logoImg{
        width: 25vw;
        position: absolute;
        top:50%;
        transform:translate(10%,-50%);
    }
    .returnImg{
        width: 8vw;
        position: absolute;
        top:50%;
        right: 2%;
        transform:translate(0%,-50%);
    }
    div{
        position: absolute;
        left: 0;
        top: 0;
        /* background: white; */
        width: 100vw;
        height: 8%;
    }
</style>